import SuccessfullyResetPasswordCard from './SuccessfullyResetPasswordCard'

export default SuccessfullyResetPasswordCard
